import Vue from 'vue'
import VAd3  from './ad3'

export default VAd3




// WEBPACK FOOTER //
// ./src/components/index/mobile/ad3/index.js